// Local Deps
import { makeGraphQLRequest } from '../../utils/requestUtils';

/* ---------------------------------------
  REQUEST SOLICITATION SEARCH
------------------------------------------*/
// THIS
export async function requestSolicitationsSearch({
  freeText,
  nsns,
  niins,
  from,
  size,
  materials,
  methods,
  minIssueDate,
  maxIssueDate,
  minReturnDate,
  maxReturnDate,
  minQuantity,
  maxQuantity,
  minEstimatedCost,
  maxEstimatedCost,
  suspectCastingFlag,
  direction,
  sortHeader,
  PurchaseRequestStatus,
}) {
  // Format Query
  const query = `query executeSolicitationsSearch(
    $freeText: String,
    $nsns: [String],
    $niins: [String],
    $from: Int,
    $size: Int,
    $materials: [Material],
    $methods: [Method],
    $minIssueDate: Date,
    $maxIssueDate: Date,
    $minReturnDate: Date,
    $maxReturnDate: Date,
    $minQuantity: Int,
    $maxQuantity: Int,
    $minEstimatedCost: Float,
    $maxEstimatedCost: Float,    
    $PurchaseRequestStatus: PurchaseRequestStatus
    $castingType: [CastingType]
    $sortType: String,
    $sortDirection: String,
  ) {
      solicitationList(

        nsns: $nsns,
        niins: $niins,
        freeText: $freeText,
        from: $from,
        size: $size,
        materials: $materials,
        methods: $methods,
        minReturnDate: $minReturnDate,
        maxReturnDate: $maxReturnDate,
        minIssueDate: $minIssueDate,
        maxIssueDate: $maxIssueDate,
        minQuantity: $minQuantity,
        maxQuantity: $maxQuantity,
        minEstimatedCost: $minEstimatedCost,
        maxEstimatedCost: $maxEstimatedCost,
        castingType: $castingType,
        sortType: $sortType,
        sortDirection: $sortDirection,
        purchaseRequestStatus: $PurchaseRequestStatus
      ) {
          solicitationList {
            id
            myPartNums{
              cage
              partNumber
            }
            purchaseRequest{
              nsnPart
              status
              quantity
              nomenclature
              
            }
            issueDate
            tooling
            toolingCages{
              cage
              accessLevel
            }
            returnDate
            um
            castingType
            estValue
            srva
            amc
            lastAward
            closes
            setAside
            mypn
            description
            process
            mold
            materialsMethods{
              material
              method
            }
          }
          meta {
            hits
            from
            size
          }
          solicitationAggregation {statusBuckets {key docCount} }

          errors {
            message
          }
      }
    }`;

  const castingType = ['Casting'];
  if (suspectCastingFlag) {
    castingType.push('Suspect Casting');
  }

  // Variables
  const variables = {
    PurchaseRequestStatus,
    niins,
    nsns,
    freeText,
    from,
    size,
    materials,
    methods,
    minIssueDate,
    maxIssueDate,
    minReturnDate,
    maxReturnDate,
    minQuantity,
    maxQuantity,
    minEstimatedCost,
    maxEstimatedCost,
    castingType,
    sortDirection: direction,
    sortType: sortHeader,
  };

  const { solicitationList } = await makeGraphQLRequest({
    query,
    variables,
  });
  return solicitationList;
}

export async function requestSolicitationsAggregations({ freeText }) {
  // Format Query
  const query = `query executeSolicitationsSearch(
    $freeText: String,
   
  ) {
      solicitationList(
        freeText: $freeText,
      
      ) {
         
          meta {
            hits
            from
            size
          }
          solicitationAggregation {statusBuckets {key docCount} }

          errors {
            message
          }
      }
    }`;

  // Variables
  const variables = {
    freeText,
  };

  const { solicitationList } = await makeGraphQLRequest({
    query,
    variables,
  });
  return solicitationList;
}

export async function requestfolderAggregations({ freeText, userId }) {
  // Format Query
  const query = `query solicitationFolderHits(
    $freeText: String,
    $userId: String
  ) {
    solicitationFolderHits(
        freeText: $freeText,
        userId: $userId,
      ) {
         
          
          solicitationAggregation {folderBuckets {key docCount} }

      
      }
    }`;

  // Variables
  const variables = {
    freeText,
    userId,
  };

  const { solicitationFolderHits } = await makeGraphQLRequest({
    query,
    variables,
  });
  return solicitationFolderHits;
}

/* ---------------------------------------
  ADD SOLICITATION SEARCH
------------------------------------------*/
// export async function addSolicitationSearch(criteria, userId) {
//   // Format Query
//   const query = `mutation addSearch(
//     $criteria: SolicitationCriteria,
//     $userId: ID
//   ) {
//       addSolicitationSearch(solicitationCriteria: $criteria, userId: $userId) {
//         methods
//         materials
//       }
//     }`;

//   // Variables
//   const variables = { criteria, userId };

//   const response = await makeGraphQLRequest({
//     query,
//     variables,
//   });
//   return response;
// }

export async function requestBidMatchingSettings(id) {
  // Format Query
  const query = `query organization(
      $id: ID
    ) {
      organization(id: $id) {
          matchSettingList {
            materials
            methods
            minimumQuantity
            minimumEstimatedCost
          }
        }
      }`;

  // Variables
  const variables = { id };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  // Any empty object is still truthy...
  if (
    response.organization.matchSettingList &&
    response.organization.matchSettingList.methods
  ) {
    response.organization.matchSettingList.methods = response.organization.matchSettingList.methods.filter(
      () => true // && method !== 'machining/other',
    );
  }
  return response;
}

export async function requestTooling(id) {
  const query = `query requestOrganizationById(
    $id: ID
  ) {
      organization(id: $id) {
        cage
        
      }
    }`;

  const variables = { id };
  const response = await makeGraphQLRequest({
    query,
    variables,
  });

  return response;
}

export async function getFolders(id, orgId) {
  const query = `query user(
    $id: ID
    $orgId: ID

    ) {
      user(id: $id) {
      name
      folders{ flagged tbq inprocess archived ace }
      }
      organization(id: $orgId) {
        cageCode
        name
        
      }
    }`;

  const variables = { id, orgId };
  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}

export async function updateFolders(criteria, userId) {
  // Format Query
  const query = `mutation updateFolders($criteria: FoldersInput, $userId: ID){ 
    updateFolders
    (folders: $criteria, userId: $userId) { 
      folders{
        flagged
      } 
    } 
  }`;

  // Variables
  const variables = { criteria, userId };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}

export async function solicitationFolderList({
  folder,
  from,
  size,
  minIssueDate,
  maxIssueDate,
  minReturnDate,
  maxReturnDate,
  suspectCastingFlag,
  direction,
  freeText,
  sortHeader,
}) {
  // Format Query
  const query = `query solicitationFolderList(
    $freeText: String,

    $folder: [String],
    $from: Int,
    $size: Int,
    $minIssueDate: Date,
    $maxIssueDate: Date,
    $minReturnDate: Date,
    $maxReturnDate: Date,
    $castingType: [CastingType]
    $sortType: String,
    $sortDirection: String,
  ) {
    solicitationFolderList(
      freeText: $freeText,
      folder:  $folder,
        from: $from,
        size: $size,
        minReturnDate: $minReturnDate,
        maxReturnDate: $maxReturnDate,
        minIssueDate: $minIssueDate,
        maxIssueDate: $maxIssueDate,
        castingType: $castingType,
        sortType: $sortType,
        sortDirection: $sortDirection
      ) {
          solicitationList {
            id
            myPartNums{
              cage
              partNumber
            }
            purchaseRequest{
              nsnPart
              status
              quantity
              nomenclature
              
            }
            issueDate
            tooling
            toolingCages{
              cage
              accessLevel
            }
            returnDate
            um
            castingType
            estValue
            srva
            amc
            lastAward
            closes
            setAside
            mypn
            description
            process
            mold
             materialsMethods{
              material
              method
            } 
          }
          meta {
            hits
            from
            size
          }
          errors {
            message
          }
      }
    }`;

  const castingType = ['Casting'];
  if (suspectCastingFlag) {
    castingType.push('Suspect Casting');
  }
  // Variables
  const variables = {
    folder,
    from,
    size,
    minIssueDate,
    maxIssueDate,
    minReturnDate,
    maxReturnDate,
    freeText,
    castingType,
    sortDirection: direction,
    sortType: sortHeader,
  };

  const res = await makeGraphQLRequest({
    query,
    variables,
  });
  return res;
}

// THIS
export async function solicitationToolingList({
  nsns,
  niins,
  from,
  size,
  minIssueDate,
  maxIssueDate,
  minReturnDate,
  maxReturnDate,
  suspectCastingFlag,
  direction,
  freeText,
  sortHeader,
}) {
  // Format Query
  const query = `query solicitationToolingList(
    $freeText: String,

    $nsns: [String],
    $niins: [String],
    $from: Int,
    $size: Int,
    $minIssueDate: Date,
    $maxIssueDate: Date,
    $minReturnDate: Date,
    $maxReturnDate: Date,
    $castingType: [CastingType]
    $sortType: String,
    $sortDirection: String,
  ) {
    solicitationToolingList(
      freeText: $freeText,
      niins:  $niins,
      nsns: $nsns,
        from: $from,
        size: $size,
        minReturnDate: $minReturnDate,
        maxReturnDate: $maxReturnDate,
        minIssueDate: $minIssueDate,
        maxIssueDate: $maxIssueDate,
        castingType: $castingType,
        sortType: $sortType,
        sortDirection: $sortDirection
      ) {
          solicitationList {
            id
            myPartNums{
              cage
              partNumber
            }
            purchaseRequest{
              nsnPart
              status
              quantity
              nomenclature
              
            }
            issueDate
            tooling
            toolingCages{
              cage
              accessLevel
            }
            returnDate
            um
            castingType
            estValue
            srva
            amc
            lastAward
            closes
            setAside
            mypn
            description
            process
            mold
            materialsMethods{
              material
              method
            }
          }
          meta {
            hits
            from
            size
          }
          errors {
            message
          }
      }
    }`;

  const castingType = ['Casting'];
  if (suspectCastingFlag) {
    castingType.push('Suspect Casting');
  }
  // Variables
  const variables = {
    nsns,
    niins,
    from,
    size,
    minIssueDate,
    maxIssueDate,
    minReturnDate,
    maxReturnDate,
    freeText,
    castingType,
    sortDirection: direction,
    sortType: sortHeader,
  };

  const res = await makeGraphQLRequest({
    query,
    variables,
  });
  return res;
}


// WEBPACK FOOTER //
// ./src/pages/SolicitationsSearch/graphql.js